export const LogoMark = ({ size = 36 }) => (
  <img
    src="/logo-mark.png"
    alt="M-Line Solutions Logo"
    width={size}
    height={size}
    style={{ width: size, height: size }}
    className="rounded-xl object-cover shrink-0 shadow-[0_0_18px_rgba(41,182,246,0.35)]"
  />
);

export const LogoFull = ({ size = 36 }) => (
  <div className="flex items-center gap-3" data-testid="navbar-brand-logo">
    <LogoMark size={size} />
    <div className="leading-none">
      <span className="font-bold text-lg tracking-tight text-slate-50" style={{ fontFamily: "'Outfit', sans-serif" }}>
        M-Line <span className="text-gradient-blue">Solutions</span>
      </span>
      <span className="block text-[9px] tracking-[0.3em] text-slate-500 mt-1 font-mono-tech">
        INNOVATE · CONNECT · GROW
      </span>
    </div>
  </div>
);
